export default {
  ifArrayIsInArray(arr1: any, arr2: any) {
    if (arr1 && arr2) {
      for (const o of arr1) {
        for (const b of arr2) {
          if (o === b) {
            return true;
          }
        }
      }
    }

    return false;
  }
};
